import { ownsPublicPage } from '../../shared/public/page-routes.cjs';
import { canonicalGuidePath } from '../../shared/public/guides.cjs';
import { getPublicRedirectTarget } from './publicRedirects';

// The backend marks SPA documents when Pug owns public URLs. Metro/native and
// deliberately disabled Pug environments must not enter a reload loop.
export function usesPublicDocuments(doc = typeof document === 'undefined' ? null : document) {
  return doc?.querySelector('meta[name="gab-public-renderer"]')?.content === 'pug';
}
export function publicDocumentHref(href, origin = typeof window === 'undefined' ? 'https://gab.ai' : window.location.origin) {
  if (typeof href !== 'string' || !href || href.startsWith('#')) return null;
  try {
    const url = new URL(href, origin);
    if (url.origin !== origin) return null;
    // Expo route groups organize screens; they are not public URL segments.
    const pathname = url.pathname.split('/').filter(part => !(part.startsWith('(') && part.endsWith(')'))).join('/');
    const target = new URL(getPublicRedirectTarget(pathname) || pathname, origin);
    if (target.origin !== origin || !ownsPublicPage(target.pathname)) return null;
    if (url.hash) target.hash = url.hash;
    // Canonicalize old Learn fragments before restoring the query string, so
    // attribution survives without visiting Docs on the way to Learn.
    const canonical = new URL(canonicalGuidePath(target.pathname + target.hash), origin);
    canonical.search = url.search || target.search;
    return canonical.pathname + canonical.search + canonical.hash;
  } catch { return null; }
}
